import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate,useParams} from "react-router-dom";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";
import { AuthMe } from "../lib/MyHttp";
import { Get,SearchDevice } from "../lib/Device";

import { useTranslation } from "react-i18next";

import swal from 'sweetalert';

import Goodbtn from "../assets/good_btn.png";
import Normalbtn from "../assets/normal_btn.png";
import Badbtn from "../assets/bad_btn.png";

import SpinIcon from '../assets/spin_stress.gif';

import ttsAudio from "../assets/sound/tts_06.mp3"; // mp3 경로 import



const About3 = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { name } = useParams();
    const { birth } = "누리온";

    const [isSwitched, setIsSwitced] = useState(false);

    const [data, setData] = useState({});

    const [DeviceNo, setDeviceNo] = useState(0);
    const [MemberNo, setMemberNo] = useState(0);
    const [DeviceSN, setDeviceSN] = useState(0);

    
    const audioRef = useRef(null);

    useEffect(() => {
        AuthMe(res => {
            setData(res);

            setDeviceSN(res.device_sn);
            setMemberNo(res.member_no);

            SearchDevice(res.device_sn, res => {
                setDeviceNo(res.device.device_no);
            });
        });
    }, []);



    useEffect(() => {
        const timer = setTimeout(() => {
             navigate('/about_2/'+name+'/'+birth+'/'+MemberNo+'/'+DeviceNo+'/'+DeviceSN);
        }, 11500); // 5초 후 이동

        return () => clearTimeout(timer); // 언마운트 시 타이머 정리
    }, [navigate,DeviceNo,MemberNo,DeviceSN]);

    // 컴포넌트 마운트 시 자동 재생
    useEffect(() => {
        const audio = audioRef.current;
        if (audio) {
            audio.play().catch(err => {
                console.warn("Autoplay failed:", err);
            });
        }
    }, []);

    return (
        <main className="main-container">

            <audio ref={audioRef} src={ttsAudio} autoPlay />

            <div className="Top_loading" style={{ display: isSwitched ? "none" : "block" }}>
                <p><img src={SpinIcon} /></p>
                <h2>측정을 시작합니다.<br />잠시만 기다려주세요.</h2>
            </div>
        </main>
    );
};

export default About3;
